/*
 * ATTENTION: This file was automatically created by RADPresentation.HTMLClient.Generator
 */

export default class RADGeneratedModels {

    public static resultDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers'];
    public static activityFeedItemDTOProperties = ['ObjectIdentValue', 'ObjectPdoId', 'ObjectType', 'ObjectTypeName', 'Principal', 'TimeStamp', 'Type', 'User'];
    public static activityFeedTimeUnitGroupDTOProperties = ['Items', 'Title', 'Unit'];
    public static activityFeedDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'MoreEntriesAvailable', 'ReturnType', 'ReturnValue', 'Status', 'TimeUnitGroups', 'TouchedMembers'];
    public static changeObjectDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'LockedBy', 'LockedObjectIdent', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers'];
    public static metadataDTOProperties = ['ErgName', 'IconUrl', 'Name', 'Tooltip'];
    public static currencyDTOProperties = ['IsActive', 'ISO4217NumberCode', 'Rate', 'Scale', 'Shortname', 'Sorting', 'Subcurrencies'];
    public static languageDTOProperties = ['CultureInfoName', 'CurrencyPattern', 'DatePattern', 'DisplayName', 'FloatingPrecision', 'IconUrl', 'IsLoginEnabled', 'ISO6391', 'TimePattern'];
    public static configurationDTOProperties = ['Currencies', 'CurrencyExchangePaths', 'DefaultCurrencyID', 'DefaultLanguage', 'GuiErrorLevel', 'Languages', 'PossibleAssoziationListViewPages', 'PossibleListViewPages', 'StartpageUIFactory', 'SystemProperties', 'UserTypeName'];
    public static typeMetaDTOProperties = ['ErgName', 'IconUrl', 'Name', 'PDO_ID', 'Tooltip'];
    public static extensionModuleDTOProperties = ['Alias', 'ErgName', 'Title', 'Types'];
    public static applicationDTOProperties = ['BuildVersion', 'Configuration', 'DeployedModules', 'Description', 'ErgName', 'ErrorMessage', 'ExpiredModules', 'IconUrl', 'IsSystemLocked', 'LastCacheUpdate', 'LicensedModules', 'Modules', 'Name', 'PDApplicationChangedTime', 'PDEnumerationValues', 'PrincipalTypeName', 'Status', 'SystemLockMessage', 'TemplateStyle', 'Tooltip'];
    public static operationDTOProperties = ['ErgName', 'HandlesMultipleInstances', 'HasRight', 'IconUrl', 'IsNeedingParameters', 'Name', 'OperationGUID', 'ShowResult', 'Tooltip'];
    public static viewDTOProperties = ['ErgName', 'IconUrl', 'Name', 'Operations', 'Tooltip', 'TypeName', 'UIListener'];
    public static columnDTOProperties = ['DotNetTypeName', 'IsFilterable', 'IsVisible', 'ListViewColumnFactory', 'ListViewPDOID', 'MLSErgName', 'Name', 'PossiblePDEnumerationValues', 'Sortable', 'UIGenerator', 'UnitNames'];
    public static listViewDTOProperties = ['AssoziationListView', 'Columns', 'DefaultOrder', 'ErgName', 'ErgNamePluralized', 'Filter', 'HideConnectedElements', 'IconUrl', 'IncludeAllPrincipals', 'IncludeBasePrincipals', 'IncludeSubPrincipals', 'IsPrincipalIndependent', 'ListViewID', 'MultiColumnSort', 'Name', 'Operations', 'RelationName', 'RowLimit', 'ShowButtonCreate', 'ShowButtonCSVExport', 'ShowButtonDelete', 'ShowButtonDisconnect', 'ShowButtonEdit', 'ShowButtonSelect', 'ShowButtonXLSExport', 'ShowFilter', 'ShowMoveButtons', 'StaticFilterExpression', 'SummaryViewAutoGenerating', 'SummaryViewParameters', 'SummaryViewUIFactory', 'Tooltip', 'TypeName', 'Types', 'UIListener'];
    public static dvgItemDTOProperties = ['Children', 'DisableNavigation', 'DotNetTypeName', 'ErgName', 'GUIReadOnly', 'IconUrl', 'IsDerived', 'IsDerivedOverwritable', 'IsDynamic', 'IsMultiSelectablePDEnumeration', 'IsPDEmbedded', 'IsPDEmbeddedMedium', 'IsPDEnumeration', 'IsToManyAssoziation', 'Length', 'ListView', 'Name', 'PossiblePDEnumerationValues', 'Required', 'Tooltip', 'UIGenerator', 'UnitErgName'];
    public static detailViewGroupDTOProperties = ['DetailViewGroups', 'ErgName', 'IconUrl', 'Items', 'Name', 'Tooltip', 'UIGenerator'];
    public static detailViewDTOProperties = ['AutoUpdateDerivedProperties', 'DerivedProperties', 'DetailViewGroups', 'DetailViewID', 'ErgName', 'IconUrl', 'Name', 'NeededProperties', 'Operations', 'Tooltip', 'TypeName', 'UIListener', 'UseShortTransactions'];
    public static navigationNodeDTOProperties = ['Action', 'ChildNodes', 'ErgName', 'IconUrl', 'IsListView', 'Name', 'PDTypeName', 'Tooltip', 'Url', 'ViewExtensionFactory', 'ViewPDO_ID'];
    public static deletionItemDTOProperties = ['ErgName', 'ErgNamePluralized', 'IconUrl', 'Name', 'Objects', 'Tooltip'];
    public static menuDTOProperties = ['UserFavoriteTree', 'UserMenuTree', 'UserNavigationTree'];
    public static userDTOProperties = ['AdditionalLoginInformations', 'ChangePasswordWithNextLogin', 'FirstName', 'IsAllowedConfigurePublicUserData', 'IsLoginWithoutPrincipal', 'IsSuperUser', 'LanguageKey', 'LastName', 'NeedsTwoFaRegistration', 'ObjectIdentValue', 'PDO_ID', 'Principal', 'Roles', 'UserName'];
    public static clientInfoDTOProperties = ['ClientInfoID', 'ID', 'Language', 'User'];
    public static principalDTOProperties = ['DefaultCurrencyID', 'FullName', 'LogoUrl', 'Name', 'PDO_ID'];
    public static clientUpdateDTOProperties = ['ApplicationMenus', 'ClientInfo', 'Configuration', 'ErrorInformation', 'ErrorMessage', 'IsModified', 'Level', 'PrincipalInfo', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers'];
    public static createdInlineObjectsDTOProperties = ['CreatedObjects', 'ErrorInformation', 'ErrorMessage', 'IsModified', 'OpenObjectPDO_ID', 'OpenObjectPDTypeName', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers'];
    public static searchObjectPositionResponseDTOProperties = ['PageID', 'RowNumber'];
    public static iteratorDTOProperties = ['ErrorInformation', 'ErrorMessage', 'ExtentCount', 'FullExtentCount', 'ID', 'IsLimited', 'IsModified', 'PDTypeName', 'ReturnHistoricalData', 'ReturnType', 'ReturnValue', 'SearchObjectPositionResponse', 'Status', 'TouchedMembers'];
    public static genericDTOProperties = ['CurrentHistoryPDO_ID', 'ErrorInformation', 'ErrorMessage', 'HistorizationDate', 'HistorizedAssemblyVersion', 'IsHistorized', 'IsModified', 'IsPrincipalIndependent', 'IsSingleton', 'ObjectIdentValue', 'PDO_Changed', 'PDO_Created', 'PDO_ID', 'PDTypeName', 'PrincipalName', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers', 'Values'];
    public static detailViewContextDTOProperties = ['AssoziationGridIterators', 'ContextParameters', 'DetailView', 'ErrorInformation', 'ErrorMessage', 'HasWriteRight', 'ID', 'IsModified', 'IsNested', 'IsNewObject', 'LockAquired', 'LockedByUser', 'LockedObjectIdent', 'LockGroupID', 'NestedDetailViewContexts', 'PersistenceContextID', 'PreviousPDOID', 'PreviousTypeName', 'PublicUserData', 'RelationNameFromPreviousObject', 'ReturnType', 'ReturnValue', 'Status', 'Subject', 'TouchedMembers'];
    public static imageSpriteDTOProperties = ['ErrorInformation', 'ErrorMessage', 'ImageMap', 'IsModified', 'ReturnType', 'ReturnValue', 'SpriteURL', 'Status', 'SvgMap', 'TouchedMembers'];
    public static inlineEditingContextDataDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'ReturnType', 'ReturnValue', 'Status', 'SubjectLocks', 'Subjects', 'TouchedMembers'];
    public static inlineEditingContextDTOProperties = ['ContextObjectPdoId', 'ContextObjectPdTypeName', 'ContextRelationName', 'DetailView', 'DetailViewContextID', 'ErrorInformation', 'ErrorMessage', 'HasCreateRight', 'HasWriteRight', 'ID', 'IsModified', 'LockGroupID', 'PersistenceContextID', 'PrimarySubAssociation', 'PrimarySubAssociationListView', 'Properties', 'ReturnType', 'ReturnValue', 'Status', 'ToManyAssociations', 'TouchedMembers'];
    public static validationDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'IsValid', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers', 'ValidationMessages'];
    public static operationResultDTOProperties = ['ContextParameters', 'ErrorInformation', 'ErrorMessage', 'IsModified', 'IsValid', 'ReturnType', 'ReturnValue', 'Status', 'Subject', 'TouchedMembers', 'ValidationMessages'];
    public static saveResultDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'IsValid', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers', 'ValidationMessages'];
    public static updateDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'IsValid', 'RefreshProperties', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers', 'ValidationMessages'];
    public static searchSuggestionsDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'ReturnType', 'ReturnValue', 'Status', 'Suggestions', 'TouchedMembers'];
    public static historizationPointDTOProperties = ['HistorizationDate', 'PDO_ID', 'Title'];
    public static historyInformationDTOProperties = ['HistorizableObjectPDO_ID', 'HistoryDate'];
    public static objectHistoryInformationsDTOProperties = ['ErrorInformation', 'ErrorMessage', 'HistoryInformation', 'IsCurrentDeleted', 'IsHistorizableType', 'IsModified', 'IsTargetHistoryObject', 'ReturnType', 'ReturnValue', 'Status', 'TargetHistoriziationPointPdoID', 'TouchedMembers'];
    public static summaryViewContextDTOProperties = ['DetailViewContext', 'ErrorInformation', 'ErrorMessage', 'IsModified', 'IsSummaryViewActive', 'ObjectHistoryInformations', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers'];
    public static tryDeletionDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'ObjectsToDelete', 'ReturnType', 'ReturnValue', 'Status', 'TouchedMembers'];
    public static updateAndValidateDTOProperties = ['ErrorInformation', 'ErrorMessage', 'IsModified', 'ReturnType', 'ReturnValue', 'SaveResultDTO', 'Status', 'TouchedMembers', 'UpdateDTO'];
    public static changePasswordResponseDTOProperties = ['IsUserLocked', 'Messages', 'Successfull', 'TwoFATokenNeeded'];
    public static hideConnectedElementsRequestDTOProperties = ['AssociationName', 'Hide'];
    public static searchObjectPositionRequestDTOProperties = ['CurrentPagingSize', 'PdoIDToFind'];
    public static pdIteratorOperatorDTOProperties = ['DisablePrincipalFilter', 'HideConnectedElementsRequest', 'HistorizationDates', 'IncludeAllPrincipals', 'IncludeBasePrincipals', 'IncludePrincipalFromSubject', 'IncludeSubPrincipals', 'IsGridIterator', 'MemoryOptimizationEnabled', 'OnlySubPrincipals', 'PrincipalFilter', 'SearchObjectPositionRequest', 'ShowCurrentObjects', 'ShowHistoricedObjects', 'ShowObjectsWithoutPrincipal', 'VisibleDeletedObjects'];
    public static groupPropertyDTOProperties = ['Expression', 'PropertyName'];
    public static aggregatePropertyDTOProperties = ['Distinct', 'Function', 'PropertyName'];
    public static iteratorAggregationDTOProperties = ['GroupProperties', 'Properties'];
    public static assignedPrincipalsDTOProperties = ['AssignedPrincipals'];
    public static searchParameterDTOProperties = ['ExtensionModules', 'HistorizationPoints'];
    public static tasksForTypeDTOProperties = ['Count', 'ErgNamePluralized', 'PDTypeId', 'PDTypeName'];
    public static taskInformationDTOProperties = ['AllAssignedTasks', 'AllTasks', 'AllUnassignedTasks', 'TaskListViewId'];
    public static notificationDTOProperties = ['IsTransient', 'Notification_PDOID', 'NotificationMessage'];
    public static systemLockNotificationDTOProperties = ['IsTransient', 'IsUserOnExceptionList', 'LockEnd', 'LockStart', 'Notification_PDOID', 'NotificationMessage', 'PreNotification'];
    public static notificationsDTOProperties = ['Notifications'];
    public static searchEntryDTOProperties = ['Alias', 'HistorizationDate', 'HistorizationGroup_PDO_ID', 'IsHistorized', 'ObjectIdentValue', 'PDO_Changed', 'PDO_ChangedBy', 'PDO_Created', 'PDO_CreatedBy', 'PDO_ID', 'Principal', 'TypeErgName', 'TypeName'];
    public static searchResultDTOProperties = ['Entries', 'ExtentCount'];
    public static searchQueryDTOProperties = ['ExtensionModules', 'From', 'HistorizationPointPDO_ID', 'IncludeHistory', 'PageSize', 'Query', 'ReverseSort', 'SearchInAllPrincipals', 'SelectedType', 'SortField', 'To'];
    public static keepAliveDTOProperties = ['LastCacheUpdate', 'LastRightCacheUpdate', 'Notifications', 'UtcNow'];
    public static loginDTOProperties = ['AssignedPrincipals', 'BlockedForSeconds', 'BlockedUntil', 'ClientInfo', 'DefaultPersistenceContext', 'IsAuthorized', 'Menus', 'Principal', 'ResultErgName', 'RightCacheCreated', 'Taskinformation', 'TwoFATokenNeeded', 'UserSpecificData'];

    public static statusEnumDTO(index: string) {
        let values = [];

        values.push('Successfull');
        values.push('Warning');
        values.push('Error');
        values.push('Exception');
        values.push('NoLegal');
        values.push('IsLockedByOther');
        values.push('SaveRequired');
        values.push('ADOException');
        values.push('ShortTransactionLockGroupError');

        return values[index];
    }

    public static activityFeedItemDTO(activityFeedItemDTO: any): any {
        let type: any = {};

        type._type = 'activityFeedItemDTO';
        type.objectIdentValue = activityFeedItemDTO.ObjectIdentValue;
        type.objectPdoId = activityFeedItemDTO.ObjectPdoId;
        type.objectType = activityFeedItemDTO.ObjectType;
        type.objectTypeName = activityFeedItemDTO.ObjectTypeName;
        type.principal = activityFeedItemDTO.Principal;
        type.timeStamp = activityFeedItemDTO.TimeStamp;
        type.type = activityFeedItemDTO.Type;
        type.user = activityFeedItemDTO.User;
        return type;
    }

    public static activityFeedTimeUnitGroupDTO(activityFeedTimeUnitGroupDTO: any): any {
        let type: any = {};

        type._type = 'activityFeedTimeUnitGroupDTO';
        type.items = [];

        if (activityFeedTimeUnitGroupDTO.Items != null) {
            for (let i5 in activityFeedTimeUnitGroupDTO.Items) {
                if(activityFeedTimeUnitGroupDTO.Items.hasOwnProperty(i5)) {
                     let typeName = 'activityFeedItemDTO';
                     type.items.push(RADGeneratedModels[typeName](activityFeedTimeUnitGroupDTO.Items[i5]));
                }
            }
        }

        type.title = activityFeedTimeUnitGroupDTO.Title;
        type.unit = activityFeedTimeUnitGroupDTO.Unit;
        return type;
    }

    public static activityFeedDTO(activityFeedDTO: any): any {
        let type: any = {};

        type._type = 'activityFeedDTO';
        type.errorInformation = {};

        if (activityFeedDTO.ErrorInformation != null) {
            for (let i3 in activityFeedDTO.ErrorInformation) {
                if (activityFeedDTO.ErrorInformation.hasOwnProperty(i3)) {
                    type.errorInformation[i3] = activityFeedDTO.ErrorInformation[i3];
                }
            }
        }

        type.errorMessage = activityFeedDTO.ErrorMessage;
        type.isModified = activityFeedDTO.IsModified;
        type.moreEntriesAvailable = activityFeedDTO.MoreEntriesAvailable;
        type.returnType = activityFeedDTO.ReturnType;
        type.returnValue = activityFeedDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(activityFeedDTO.Status);
        type.timeUnitGroups = [];

        if (activityFeedDTO.TimeUnitGroups != null) {
            for (let i4 in activityFeedDTO.TimeUnitGroups) {
                if(activityFeedDTO.TimeUnitGroups.hasOwnProperty(i4)) {
                     let typeName = 'activityFeedTimeUnitGroupDTO';
                     type.timeUnitGroups.push(RADGeneratedModels[typeName](activityFeedDTO.TimeUnitGroups[i4]));
                }
            }
        }

        type.touchedMembers = [];

        if (activityFeedDTO.TouchedMembers != null) {
            for (let i6 in activityFeedDTO.TouchedMembers) {
                if(activityFeedDTO.TouchedMembers.hasOwnProperty(i6)) {
                    type.touchedMembers.push(activityFeedDTO.TouchedMembers[i6]);
                }
            }
        }

        return type;
    }

    public static changeObjectDTO(changeObjectDTO: any): any {
        let type: any = {};

        type._type = 'changeObjectDTO';
        type.errorInformation = {};

        if (changeObjectDTO.ErrorInformation != null) {
            for (let i7 in changeObjectDTO.ErrorInformation) {
                if (changeObjectDTO.ErrorInformation.hasOwnProperty(i7)) {
                    type.errorInformation[i7] = changeObjectDTO.ErrorInformation[i7];
                }
            }
        }

        type.errorMessage = changeObjectDTO.ErrorMessage;
        type.isModified = changeObjectDTO.IsModified;
        type.lockedBy = changeObjectDTO.LockedBy;
        type.lockedObjectIdent = changeObjectDTO.LockedObjectIdent;
        type.returnType = changeObjectDTO.ReturnType;
        type.returnValue = changeObjectDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(changeObjectDTO.Status);
        type.touchedMembers = [];

        if (changeObjectDTO.TouchedMembers != null) {
            for (let i8 in changeObjectDTO.TouchedMembers) {
                if(changeObjectDTO.TouchedMembers.hasOwnProperty(i8)) {
                    type.touchedMembers.push(changeObjectDTO.TouchedMembers[i8]);
                }
            }
        }

        return type;
    }

    public static currencyDTO(currencyDTO: any): any {
        let type: any = {};

        type._type = 'currencyDTO';
        type.isActive = currencyDTO.IsActive;
        type.isO4217NumberCode = currencyDTO.ISO4217NumberCode;
        type.rate = currencyDTO.Rate;
        type.scale = currencyDTO.Scale;
        type.shortname = currencyDTO.Shortname;
        type.sorting = currencyDTO.Sorting;
        type.subcurrencies = [];

        if (currencyDTO.Subcurrencies != null) {
            for (let i10 in currencyDTO.Subcurrencies) {
                if(currencyDTO.Subcurrencies.hasOwnProperty(i10)) {
                     let typeName = 'currencyDTO';
                     type.subcurrencies.push(RADGeneratedModels[typeName](currencyDTO.Subcurrencies[i10]));
                }
            }
        }

        return type;
    }

    public static languageDTO(languageDTO: any): any {
        let type: any = {};

        type._type = 'languageDTO';
        type.cultureInfoName = languageDTO.CultureInfoName;
        type.currencyPattern = languageDTO.CurrencyPattern;
        type.datePattern = languageDTO.DatePattern;
        type.displayName = languageDTO.DisplayName;
        type.floatingPrecision = languageDTO.FloatingPrecision;
        type.iconUrl = languageDTO.IconUrl;
        type.isLoginEnabled = languageDTO.IsLoginEnabled;
        type.iso6391 = languageDTO.ISO6391;
        type.timePattern = languageDTO.TimePattern;
        return type;
    }

    public static guiErrorLevel(index: string) {
        let values = [];

        values.push('None');
        values.push('Low');
        values.push('Middle');
        values.push('High');

        return values[index];
    }

    public static configurationDTO(configurationDTO: any): any {
        let type: any = {};

        type._type = 'configurationDTO';
        type.currencies = {};

        if (configurationDTO.Currencies != null) {
            for (let i9 in configurationDTO.Currencies) {
                if (configurationDTO.Currencies.hasOwnProperty(i9)) {
                    type.currencies[i9] = RADGeneratedModels.currencyDTO(configurationDTO.Currencies[i9]);
                }
            }
        }

        type.currencyExchangePaths = {};

        if (configurationDTO.CurrencyExchangePaths != null) {
            for (let i11 in configurationDTO.CurrencyExchangePaths) {
                if (configurationDTO.CurrencyExchangePaths.hasOwnProperty(i11)) {
                    type.currencyExchangePaths[i11] = configurationDTO.CurrencyExchangePaths[i11];
                }
            }
        }

        type.defaultCurrencyID = configurationDTO.DefaultCurrencyID;
        if (configurationDTO.DefaultLanguage != null) {
            let typeName = 'languageDTO';
            type.defaultLanguage = RADGeneratedModels[typeName](configurationDTO.DefaultLanguage);
        } else {
            type.defaultLanguage = null;
        }

        type.guiErrorLevel = RADGeneratedModels.guiErrorLevel(configurationDTO.GuiErrorLevel);
        type.languages = [];

        if (configurationDTO.Languages != null) {
            for (let i12 in configurationDTO.Languages) {
                if(configurationDTO.Languages.hasOwnProperty(i12)) {
                     let typeName = 'languageDTO';
                     type.languages.push(RADGeneratedModels[typeName](configurationDTO.Languages[i12]));
                }
            }
        }

        type.possibleAssoziationListViewPages = [];

        if (configurationDTO.PossibleAssoziationListViewPages != null) {
            for (let i13 in configurationDTO.PossibleAssoziationListViewPages) {
                if(configurationDTO.PossibleAssoziationListViewPages.hasOwnProperty(i13)) {
                    type.possibleAssoziationListViewPages.push(configurationDTO.PossibleAssoziationListViewPages[i13]);
                }
            }
        }

        type.possibleListViewPages = [];

        if (configurationDTO.PossibleListViewPages != null) {
            for (let i14 in configurationDTO.PossibleListViewPages) {
                if(configurationDTO.PossibleListViewPages.hasOwnProperty(i14)) {
                    type.possibleListViewPages.push(configurationDTO.PossibleListViewPages[i14]);
                }
            }
        }

        type.startpageUIFactory = configurationDTO.StartpageUIFactory;
        type.systemProperties = {};

        if (configurationDTO.SystemProperties != null) {
            for (let i15 in configurationDTO.SystemProperties) {
                if (configurationDTO.SystemProperties.hasOwnProperty(i15)) {
                    type.systemProperties[i15] = configurationDTO.SystemProperties[i15];
                }
            }
        }

        type.userTypeName = configurationDTO.UserTypeName;
        return type;
    }

    public static typeMetaDTO(typeMetaDTO: any): any {
        let type: any = {};

        type._type = 'typeMetaDTO';
        type.ergName = typeMetaDTO.ErgName;
        type.iconUrl = typeMetaDTO.IconUrl;
        type.name = typeMetaDTO.Name;
        type.pdoId = typeMetaDTO.PDO_ID;
        type.tooltip = typeMetaDTO.Tooltip;
        return type;
    }

    public static extensionModuleDTO(extensionModuleDTO: any): any {
        let type: any = {};

        type._type = 'extensionModuleDTO';
        type.alias = extensionModuleDTO.Alias;
        type.ergName = extensionModuleDTO.ErgName;
        type.title = extensionModuleDTO.Title;
        type.types = [];

        if (extensionModuleDTO.Types != null) {
            for (let i20 in extensionModuleDTO.Types) {
                if(extensionModuleDTO.Types.hasOwnProperty(i20)) {
                     let typeName = 'typeMetaDTO';
                     type.types.push(RADGeneratedModels[typeName](extensionModuleDTO.Types[i20]));
                }
            }
        }

        return type;
    }

    public static applicationDTO(applicationDTO: any): any {
        let type: any = {};

        type._type = 'applicationDTO';
        type.buildVersion = applicationDTO.BuildVersion;
        if (applicationDTO.Configuration != null) {
            let typeName = 'configurationDTO';
            type.configuration = RADGeneratedModels[typeName](applicationDTO.Configuration);
        } else {
            type.configuration = null;
        }

        type.deployedModules = [];

        if (applicationDTO.DeployedModules != null) {
            for (let i16 in applicationDTO.DeployedModules) {
                if(applicationDTO.DeployedModules.hasOwnProperty(i16)) {
                    type.deployedModules.push(applicationDTO.DeployedModules[i16]);
                }
            }
        }

        type.description = applicationDTO.Description;
        type.ergName = applicationDTO.ErgName;
        type.errorMessage = applicationDTO.ErrorMessage;
        type.expiredModules = [];

        if (applicationDTO.ExpiredModules != null) {
            for (let i17 in applicationDTO.ExpiredModules) {
                if(applicationDTO.ExpiredModules.hasOwnProperty(i17)) {
                    type.expiredModules.push(applicationDTO.ExpiredModules[i17]);
                }
            }
        }

        type.iconUrl = applicationDTO.IconUrl;
        type.isSystemLocked = applicationDTO.IsSystemLocked;
        type.lastCacheUpdate = applicationDTO.LastCacheUpdate;
        type.licensedModules = [];

        if (applicationDTO.LicensedModules != null) {
            for (let i18 in applicationDTO.LicensedModules) {
                if(applicationDTO.LicensedModules.hasOwnProperty(i18)) {
                    type.licensedModules.push(applicationDTO.LicensedModules[i18]);
                }
            }
        }

        type.modules = {};

        if (applicationDTO.Modules != null) {
            for (let i19 in applicationDTO.Modules) {
                if (applicationDTO.Modules.hasOwnProperty(i19)) {
                    type.modules[i19] = RADGeneratedModels.extensionModuleDTO(applicationDTO.Modules[i19]);
                }
            }
        }

        type.name = applicationDTO.Name;
        type.pdApplicationChangedTime = applicationDTO.PDApplicationChangedTime;
        type.pdEnumerationValues = {};

        if (applicationDTO.PDEnumerationValues != null) {
            for (let i21 in applicationDTO.PDEnumerationValues) {
                if (applicationDTO.PDEnumerationValues.hasOwnProperty(i21)) {
                    type.pdEnumerationValues[i21] = applicationDTO.PDEnumerationValues[i21];
                }
            }
        }

        type.principalTypeName = applicationDTO.PrincipalTypeName;
        type.status = RADGeneratedModels.statusEnumDTO(applicationDTO.Status);
        type.systemLockMessage = applicationDTO.SystemLockMessage;
        type.templateStyle = applicationDTO.TemplateStyle;
        type.tooltip = applicationDTO.Tooltip;
        return type;
    }

    public static operationDTO(operationDTO: any): any {
        let type: any = {};

        type._type = 'operationDTO';
        type.ergName = operationDTO.ErgName;
        type.handlesMultipleInstances = operationDTO.HandlesMultipleInstances;
        type.hasRight = operationDTO.HasRight;
        type.iconUrl = operationDTO.IconUrl;
        type.isNeedingParameters = operationDTO.IsNeedingParameters;
        type.name = operationDTO.Name;
        type.operationGUID = operationDTO.OperationGUID;
        type.showResult = operationDTO.ShowResult;
        type.tooltip = operationDTO.Tooltip;
        return type;
    }

    public static columnDTO(columnDTO: any): any {
        let type: any = {};

        type._type = 'columnDTO';
        type.dotNetTypeName = columnDTO.DotNetTypeName;
        type.isFilterable = columnDTO.IsFilterable;
        type.isVisible = columnDTO.IsVisible;
        type.listViewColumnFactory = columnDTO.ListViewColumnFactory;
        type.listViewPDOID = columnDTO.ListViewPDOID;
        type.mlsErgName = {};

        if (columnDTO.MLSErgName != null) {
            for (let i29 in columnDTO.MLSErgName) {
                if (columnDTO.MLSErgName.hasOwnProperty(i29)) {
                    type.mlsErgName[i29] = columnDTO.MLSErgName[i29];
                }
            }
        }

        type.name = columnDTO.Name;
        type.possiblePDEnumerationValues = {};

        if (columnDTO.PossiblePDEnumerationValues != null) {
            for (let i30 in columnDTO.PossiblePDEnumerationValues) {
                if (columnDTO.PossiblePDEnumerationValues.hasOwnProperty(i30)) {
                    type.possiblePDEnumerationValues[i30] = columnDTO.PossiblePDEnumerationValues[i30];
                }
            }
        }

        type.sortable = columnDTO.Sortable;
        type.uiGenerator = columnDTO.UIGenerator;
        type.unitNames = {};

        if (columnDTO.UnitNames != null) {
            for (let i31 in columnDTO.UnitNames) {
                if (columnDTO.UnitNames.hasOwnProperty(i31)) {
                    type.unitNames[i31] = columnDTO.UnitNames[i31];
                }
            }
        }

        return type;
    }

    public static listViewDTO(listViewDTO: any): any {
        let type: any = {};

        type._type = 'listViewDTO';
        type.assoziationListView = listViewDTO.AssoziationListView;
        type.columns = [];

        if (listViewDTO.Columns != null) {
            for (let i28 in listViewDTO.Columns) {
                if(listViewDTO.Columns.hasOwnProperty(i28)) {
                     let typeName = 'columnDTO';
                     type.columns.push(RADGeneratedModels[typeName](listViewDTO.Columns[i28]));
                }
            }
        }

        type.defaultOrder = listViewDTO.DefaultOrder;
        type.ergName = listViewDTO.ErgName;
        type.ergNamePluralized = listViewDTO.ErgNamePluralized;
        type.filter = listViewDTO.Filter;
        type.hideConnectedElements = listViewDTO.HideConnectedElements;
        type.iconUrl = listViewDTO.IconUrl;
        type.includeAllPrincipals = listViewDTO.IncludeAllPrincipals;
        type.includeBasePrincipals = listViewDTO.IncludeBasePrincipals;
        type.includeSubPrincipals = listViewDTO.IncludeSubPrincipals;
        type.isPrincipalIndependent = listViewDTO.IsPrincipalIndependent;
        type.listViewID = listViewDTO.ListViewID;
        type.multiColumnSort = listViewDTO.MultiColumnSort;
        type.name = listViewDTO.Name;
        type.operations = [];

        if (listViewDTO.Operations != null) {
            for (let i32 in listViewDTO.Operations) {
                if(listViewDTO.Operations.hasOwnProperty(i32)) {
                     let typeName = 'operationDTO';
                     type.operations.push(RADGeneratedModels[typeName](listViewDTO.Operations[i32]));
                }
            }
        }

        type.relationName = listViewDTO.RelationName;
        type.rowLimit = listViewDTO.RowLimit;
        type.showButtonCreate = listViewDTO.ShowButtonCreate;
        type.showButtonCSVExport = listViewDTO.ShowButtonCSVExport;
        type.showButtonDelete = listViewDTO.ShowButtonDelete;
        type.showButtonDisconnect = listViewDTO.ShowButtonDisconnect;
        type.showButtonEdit = listViewDTO.ShowButtonEdit;
        type.showButtonSelect = listViewDTO.ShowButtonSelect;
        type.showButtonXLSExport = listViewDTO.ShowButtonXLSExport;
        type.showFilter = listViewDTO.ShowFilter;
        type.showMoveButtons = listViewDTO.ShowMoveButtons;
        type.staticFilterExpression = listViewDTO.StaticFilterExpression;
        type.summaryViewAutoGenerating = listViewDTO.SummaryViewAutoGenerating;
        type.summaryViewParameters = listViewDTO.SummaryViewParameters;
        type.summaryViewUIFactory = listViewDTO.SummaryViewUIFactory;
        type.tooltip = listViewDTO.Tooltip;
        type.typeName = listViewDTO.TypeName;
        type.types = [];

        if (listViewDTO.Types != null) {
            for (let i33 in listViewDTO.Types) {
                if(listViewDTO.Types.hasOwnProperty(i33)) {
                     let typeName = 'typeMetaDTO';
                     type.types.push(RADGeneratedModels[typeName](listViewDTO.Types[i33]));
                }
            }
        }

        type.uiListener = listViewDTO.UIListener;
        return type;
    }

    public static dvgItemDTO(dvgItemDTO: any): any {
        let type: any = {};

        type._type = 'dvgItemDTO';
        type.children = [];

        if (dvgItemDTO.Children != null) {
            for (let i27 in dvgItemDTO.Children) {
                if(dvgItemDTO.Children.hasOwnProperty(i27)) {
                     let typeName = 'dvgItemDTO';
                     type.children.push(RADGeneratedModels[typeName](dvgItemDTO.Children[i27]));
                }
            }
        }

        type.disableNavigation = dvgItemDTO.DisableNavigation;
        type.dotNetTypeName = dvgItemDTO.DotNetTypeName;
        type.ergName = dvgItemDTO.ErgName;
        type.guiReadOnly = dvgItemDTO.GUIReadOnly;
        type.iconUrl = dvgItemDTO.IconUrl;
        type.isDerived = dvgItemDTO.IsDerived;
        type.isDerivedOverwritable = dvgItemDTO.IsDerivedOverwritable;
        type.isDynamic = dvgItemDTO.IsDynamic;
        type.isMultiSelectablePDEnumeration = dvgItemDTO.IsMultiSelectablePDEnumeration;
        type.isPDEmbedded = dvgItemDTO.IsPDEmbedded;
        type.isPDEmbeddedMedium = dvgItemDTO.IsPDEmbeddedMedium;
        type.isPDEnumeration = dvgItemDTO.IsPDEnumeration;
        type.isToManyAssoziation = dvgItemDTO.IsToManyAssoziation;
        type.length = dvgItemDTO.Length;
        if (dvgItemDTO.ListView != null) {
            let typeName = 'listViewDTO';
            type.listView = RADGeneratedModels[typeName](dvgItemDTO.ListView);
        } else {
            type.listView = null;
        }

        type.name = dvgItemDTO.Name;
        type.possiblePDEnumerationValues = {};

        if (dvgItemDTO.PossiblePDEnumerationValues != null) {
            for (let i34 in dvgItemDTO.PossiblePDEnumerationValues) {
                if (dvgItemDTO.PossiblePDEnumerationValues.hasOwnProperty(i34)) {
                    type.possiblePDEnumerationValues[i34] = dvgItemDTO.PossiblePDEnumerationValues[i34];
                }
            }
        }

        type.required = dvgItemDTO.Required;
        type.tooltip = dvgItemDTO.Tooltip;
        type.uiGenerator = dvgItemDTO.UIGenerator;
        type.unitErgName = dvgItemDTO.UnitErgName;
        return type;
    }

    public static detailViewGroupDTO(detailViewGroupDTO: any): any {
        let type: any = {};

        type._type = 'detailViewGroupDTO';
        type.detailViewGroups = [];

        if (detailViewGroupDTO.DetailViewGroups != null) {
            for (let i25 in detailViewGroupDTO.DetailViewGroups) {
                if(detailViewGroupDTO.DetailViewGroups.hasOwnProperty(i25)) {
                     let typeName = 'detailViewGroupDTO';
                     type.detailViewGroups.push(RADGeneratedModels[typeName](detailViewGroupDTO.DetailViewGroups[i25]));
                }
            }
        }

        type.ergName = detailViewGroupDTO.ErgName;
        type.iconUrl = detailViewGroupDTO.IconUrl;
        type.items = [];

        if (detailViewGroupDTO.Items != null) {
            for (let i26 in detailViewGroupDTO.Items) {
                if(detailViewGroupDTO.Items.hasOwnProperty(i26)) {
                     let typeName = 'dvgItemDTO';
                     type.items.push(RADGeneratedModels[typeName](detailViewGroupDTO.Items[i26]));
                }
            }
        }

        type.name = detailViewGroupDTO.Name;
        type.tooltip = detailViewGroupDTO.Tooltip;
        type.uiGenerator = detailViewGroupDTO.UIGenerator;
        return type;
    }

    public static detailViewDTO(detailViewDTO: any): any {
        let type: any = {};

        type._type = 'detailViewDTO';
        type.autoUpdateDerivedProperties = detailViewDTO.AutoUpdateDerivedProperties;
        type.derivedProperties = [];

        if (detailViewDTO.DerivedProperties != null) {
            for (let i23 in detailViewDTO.DerivedProperties) {
                if(detailViewDTO.DerivedProperties.hasOwnProperty(i23)) {
                    type.derivedProperties.push(detailViewDTO.DerivedProperties[i23]);
                }
            }
        }

        type.detailViewGroups = [];

        if (detailViewDTO.DetailViewGroups != null) {
            for (let i24 in detailViewDTO.DetailViewGroups) {
                if(detailViewDTO.DetailViewGroups.hasOwnProperty(i24)) {
                     let typeName = 'detailViewGroupDTO';
                     type.detailViewGroups.push(RADGeneratedModels[typeName](detailViewDTO.DetailViewGroups[i24]));
                }
            }
        }

        type.detailViewID = detailViewDTO.DetailViewID;
        type.ergName = detailViewDTO.ErgName;
        type.iconUrl = detailViewDTO.IconUrl;
        type.name = detailViewDTO.Name;
        type.neededProperties = [];

        if (detailViewDTO.NeededProperties != null) {
            for (let i35 in detailViewDTO.NeededProperties) {
                if(detailViewDTO.NeededProperties.hasOwnProperty(i35)) {
                    type.neededProperties.push(detailViewDTO.NeededProperties[i35]);
                }
            }
        }

        type.operations = [];

        if (detailViewDTO.Operations != null) {
            for (let i36 in detailViewDTO.Operations) {
                if(detailViewDTO.Operations.hasOwnProperty(i36)) {
                     let typeName = 'operationDTO';
                     type.operations.push(RADGeneratedModels[typeName](detailViewDTO.Operations[i36]));
                }
            }
        }

        type.tooltip = detailViewDTO.Tooltip;
        type.typeName = detailViewDTO.TypeName;
        type.uiListener = detailViewDTO.UIListener;
        type.useShortTransactions = detailViewDTO.UseShortTransactions;
        return type;
    }

    public static viewDTO(viewDTO: any): any {
        let type: any = {};

        type._type = 'viewDTO';
        type.ergName = viewDTO.ErgName;
        type.iconUrl = viewDTO.IconUrl;
        type.name = viewDTO.Name;
        type.operations = [];

        if (viewDTO.Operations != null) {
            for (let i22 in viewDTO.Operations) {
                if(viewDTO.Operations.hasOwnProperty(i22)) {
                     let typeName = 'operationDTO';
                     type.operations.push(RADGeneratedModels[typeName](viewDTO.Operations[i22]));
                }
            }
        }

        type.tooltip = viewDTO.Tooltip;
        type.typeName = viewDTO.TypeName;
        type.uiListener = viewDTO.UIListener;
        return type;
    }

    public static navigationNodeDTO(navigationNodeDTO: any): any {
        let type: any = {};

        type._type = 'navigationNodeDTO';
        type.action = navigationNodeDTO.Action;
        type.childNodes = [];

        if (navigationNodeDTO.ChildNodes != null) {
            for (let i41 in navigationNodeDTO.ChildNodes) {
                if(navigationNodeDTO.ChildNodes.hasOwnProperty(i41)) {
                     let typeName = 'navigationNodeDTO';
                     type.childNodes.push(RADGeneratedModels[typeName](navigationNodeDTO.ChildNodes[i41]));
                }
            }
        }

        type.ergName = navigationNodeDTO.ErgName;
        type.iconUrl = navigationNodeDTO.IconUrl;
        type.isListView = navigationNodeDTO.IsListView;
        type.name = navigationNodeDTO.Name;
        type.pdTypeName = navigationNodeDTO.PDTypeName;
        type.tooltip = navigationNodeDTO.Tooltip;
        type.url = navigationNodeDTO.Url;
        type.viewExtensionFactory = navigationNodeDTO.ViewExtensionFactory;
        type.viewPDOID = navigationNodeDTO.ViewPDO_ID;
        return type;
    }

    public static deletionItemDTO(deletionItemDTO: any): any {
        let type: any = {};

        type._type = 'deletionItemDTO';
        type.ergName = deletionItemDTO.ErgName;
        type.ergNamePluralized = deletionItemDTO.ErgNamePluralized;
        type.iconUrl = deletionItemDTO.IconUrl;
        type.name = deletionItemDTO.Name;
        type.objects = [];

        if (deletionItemDTO.Objects != null) {
            for (let i42 in deletionItemDTO.Objects) {
                if(deletionItemDTO.Objects.hasOwnProperty(i42)) {
                    type.objects.push(deletionItemDTO.Objects[i42]);
                }
            }
        }

        type.tooltip = deletionItemDTO.Tooltip;
        return type;
    }

    public static metadataDTO(metadataDTO: any): any {
        let type: any = {};

        type._type = 'metadataDTO';
        type.ergName = metadataDTO.ErgName;
        type.iconUrl = metadataDTO.IconUrl;
        type.name = metadataDTO.Name;
        type.tooltip = metadataDTO.Tooltip;
        return type;
    }

    public static menuDTO(menuDTO: any): any {
        let type: any = {};

        type._type = 'menuDTO';
        if (menuDTO.UserFavoriteTree != null) {
            let typeName = 'navigationNodeDTO';
            type.userFavoriteTree = RADGeneratedModels[typeName](menuDTO.UserFavoriteTree);
        } else {
            type.userFavoriteTree = null;
        }

        if (menuDTO.UserMenuTree != null) {
            let typeName = 'navigationNodeDTO';
            type.userMenuTree = RADGeneratedModels[typeName](menuDTO.UserMenuTree);
        } else {
            type.userMenuTree = null;
        }

        if (menuDTO.UserNavigationTree != null) {
            let typeName = 'navigationNodeDTO';
            type.userNavigationTree = RADGeneratedModels[typeName](menuDTO.UserNavigationTree);
        } else {
            type.userNavigationTree = null;
        }

        return type;
    }

    public static userDTO(userDTO: any): any {
        let type: any = {};

        type._type = 'userDTO';
        type.additionalLoginInformations = {};

        if (userDTO.AdditionalLoginInformations != null) {
            for (let i44 in userDTO.AdditionalLoginInformations) {
                if (userDTO.AdditionalLoginInformations.hasOwnProperty(i44)) {
                    type.additionalLoginInformations[i44] = userDTO.AdditionalLoginInformations[i44];
                }
            }
        }

        type.changePasswordWithNextLogin = userDTO.ChangePasswordWithNextLogin;
        type.firstName = userDTO.FirstName;
        type.isAllowedConfigurePublicUserData = userDTO.IsAllowedConfigurePublicUserData;
        type.isLoginWithoutPrincipal = userDTO.IsLoginWithoutPrincipal;
        type.isSuperUser = userDTO.IsSuperUser;
        type.languageKey = userDTO.LanguageKey;
        type.lastName = userDTO.LastName;
        type.needsTwoFaRegistration = userDTO.NeedsTwoFaRegistration;
        type.objectIdentValue = userDTO.ObjectIdentValue;
        type.pdoId = userDTO.PDO_ID;
        type.principal = userDTO.Principal;
        type.roles = [];

        if (userDTO.Roles != null) {
            for (let i45 in userDTO.Roles) {
                if(userDTO.Roles.hasOwnProperty(i45)) {
                    type.roles.push(userDTO.Roles[i45]);
                }
            }
        }

        type.userName = userDTO.UserName;
        return type;
    }

    public static clientInfoDTO(clientInfoDTO: any): any {
        let type: any = {};

        type._type = 'clientInfoDTO';
        type.clientInfoID = clientInfoDTO.ClientInfoID;
        type.id = clientInfoDTO.ID;
        type.language = clientInfoDTO.Language;
        if (clientInfoDTO.User != null) {
            let typeName = 'userDTO';
            type.user = RADGeneratedModels[typeName](clientInfoDTO.User);
        } else {
            type.user = null;
        }

        return type;
    }

    public static clientUpdateLevelDTO(index: string) {
        let values = [];

        values.push('Full');
        values.push('OnlyMenus');
        values.push('OnlyUserInformation');
        values.push('OnlyApplicationInformation');

        return values[index];
    }

    public static principalDTO(principalDTO: any): any {
        let type: any = {};

        type._type = 'principalDTO';
        type.defaultCurrencyID = principalDTO.DefaultCurrencyID;
        type.fullName = principalDTO.FullName;
        type.logoUrl = principalDTO.LogoUrl;
        type.name = principalDTO.Name;
        type.pdoId = principalDTO.PDO_ID;
        return type;
    }

    public static clientUpdateDTO(clientUpdateDTO: any): any {
        let type: any = {};

        type._type = 'clientUpdateDTO';
        if (clientUpdateDTO.ApplicationMenus != null) {
            let typeName = 'menuDTO';
            type.applicationMenus = RADGeneratedModels[typeName](clientUpdateDTO.ApplicationMenus);
        } else {
            type.applicationMenus = null;
        }

        if (clientUpdateDTO.ClientInfo != null) {
            let typeName = 'clientInfoDTO';
            type.clientInfo = RADGeneratedModels[typeName](clientUpdateDTO.ClientInfo);
        } else {
            type.clientInfo = null;
        }

        if (clientUpdateDTO.Configuration != null) {
            let typeName = 'configurationDTO';
            type.configuration = RADGeneratedModels[typeName](clientUpdateDTO.Configuration);
        } else {
            type.configuration = null;
        }

        type.errorInformation = {};

        if (clientUpdateDTO.ErrorInformation != null) {
            for (let i46 in clientUpdateDTO.ErrorInformation) {
                if (clientUpdateDTO.ErrorInformation.hasOwnProperty(i46)) {
                    type.errorInformation[i46] = clientUpdateDTO.ErrorInformation[i46];
                }
            }
        }

        type.errorMessage = clientUpdateDTO.ErrorMessage;
        type.isModified = clientUpdateDTO.IsModified;
        type.level = RADGeneratedModels.clientUpdateLevelDTO(clientUpdateDTO.Level);
        if (clientUpdateDTO.PrincipalInfo != null) {
            let typeName = 'principalDTO';
            type.principalInfo = RADGeneratedModels[typeName](clientUpdateDTO.PrincipalInfo);
        } else {
            type.principalInfo = null;
        }

        type.returnType = clientUpdateDTO.ReturnType;
        type.returnValue = clientUpdateDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(clientUpdateDTO.Status);
        type.touchedMembers = [];

        if (clientUpdateDTO.TouchedMembers != null) {
            for (let i47 in clientUpdateDTO.TouchedMembers) {
                if(clientUpdateDTO.TouchedMembers.hasOwnProperty(i47)) {
                    type.touchedMembers.push(clientUpdateDTO.TouchedMembers[i47]);
                }
            }
        }

        return type;
    }

    public static createdInlineObjectsDTO(createdInlineObjectsDTO: any): any {
        let type: any = {};

        type._type = 'createdInlineObjectsDTO';
        type.createdObjects = {};

        if (createdInlineObjectsDTO.CreatedObjects != null) {
            for (let i48 in createdInlineObjectsDTO.CreatedObjects) {
                if (createdInlineObjectsDTO.CreatedObjects.hasOwnProperty(i48)) {
                    type.createdObjects[i48] = createdInlineObjectsDTO.CreatedObjects[i48];
                }
            }
        }

        type.errorInformation = {};

        if (createdInlineObjectsDTO.ErrorInformation != null) {
            for (let i49 in createdInlineObjectsDTO.ErrorInformation) {
                if (createdInlineObjectsDTO.ErrorInformation.hasOwnProperty(i49)) {
                    type.errorInformation[i49] = createdInlineObjectsDTO.ErrorInformation[i49];
                }
            }
        }

        type.errorMessage = createdInlineObjectsDTO.ErrorMessage;
        type.isModified = createdInlineObjectsDTO.IsModified;
        type.openObjectPDOID = createdInlineObjectsDTO.OpenObjectPDO_ID;
        type.openObjectPDTypeName = createdInlineObjectsDTO.OpenObjectPDTypeName;
        type.returnType = createdInlineObjectsDTO.ReturnType;
        type.returnValue = createdInlineObjectsDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(createdInlineObjectsDTO.Status);
        type.touchedMembers = [];

        if (createdInlineObjectsDTO.TouchedMembers != null) {
            for (let i50 in createdInlineObjectsDTO.TouchedMembers) {
                if(createdInlineObjectsDTO.TouchedMembers.hasOwnProperty(i50)) {
                    type.touchedMembers.push(createdInlineObjectsDTO.TouchedMembers[i50]);
                }
            }
        }

        return type;
    }

    public static searchObjectPositionResponseDTO(searchObjectPositionResponseDTO: any): any {
        let type: any = {};

        type._type = 'searchObjectPositionResponseDTO';
        type.pageID = searchObjectPositionResponseDTO.PageID;
        type.rowNumber = searchObjectPositionResponseDTO.RowNumber;
        return type;
    }

    public static iteratorDTO(iteratorDTO: any): any {
        let type: any = {};

        type._type = 'iteratorDTO';
        type.errorInformation = {};

        if (iteratorDTO.ErrorInformation != null) {
            for (let i52 in iteratorDTO.ErrorInformation) {
                if (iteratorDTO.ErrorInformation.hasOwnProperty(i52)) {
                    type.errorInformation[i52] = iteratorDTO.ErrorInformation[i52];
                }
            }
        }

        type.errorMessage = iteratorDTO.ErrorMessage;
        type.extentCount = iteratorDTO.ExtentCount;
        type.fullExtentCount = iteratorDTO.FullExtentCount;
        type.id = iteratorDTO.ID;
        type.isLimited = iteratorDTO.IsLimited;
        type.isModified = iteratorDTO.IsModified;
        type.pdTypeName = iteratorDTO.PDTypeName;
        type.returnHistoricalData = iteratorDTO.ReturnHistoricalData;
        type.returnType = iteratorDTO.ReturnType;
        type.returnValue = iteratorDTO.ReturnValue;
        if (iteratorDTO.SearchObjectPositionResponse != null) {
            let typeName = 'searchObjectPositionResponseDTO';
            type.searchObjectPositionResponse = RADGeneratedModels[typeName](iteratorDTO.SearchObjectPositionResponse);
        } else {
            type.searchObjectPositionResponse = null;
        }

        type.status = RADGeneratedModels.statusEnumDTO(iteratorDTO.Status);
        type.touchedMembers = [];

        if (iteratorDTO.TouchedMembers != null) {
            for (let i53 in iteratorDTO.TouchedMembers) {
                if(iteratorDTO.TouchedMembers.hasOwnProperty(i53)) {
                    type.touchedMembers.push(iteratorDTO.TouchedMembers[i53]);
                }
            }
        }

        return type;
    }

    public static genericDTO(genericDTO: any): any {
        let type: any = {};

        type._type = 'genericDTO';
        type.currentHistoryPDOID = genericDTO.CurrentHistoryPDO_ID;
        type.errorInformation = {};

        if (genericDTO.ErrorInformation != null) {
            for (let i58 in genericDTO.ErrorInformation) {
                if (genericDTO.ErrorInformation.hasOwnProperty(i58)) {
                    type.errorInformation[i58] = genericDTO.ErrorInformation[i58];
                }
            }
        }

        type.errorMessage = genericDTO.ErrorMessage;
        type.historizationDate = genericDTO.HistorizationDate;
        type.historizedAssemblyVersion = genericDTO.HistorizedAssemblyVersion;
        type.isHistorized = genericDTO.IsHistorized;
        type.isModified = genericDTO.IsModified;
        type.isPrincipalIndependent = genericDTO.IsPrincipalIndependent;
        type.isSingleton = genericDTO.IsSingleton;
        type.objectIdentValue = genericDTO.ObjectIdentValue;
        type.pdOChanged = genericDTO.PDO_Changed;
        type.pdOCreated = genericDTO.PDO_Created;
        type.pdoId = genericDTO.PDO_ID;
        type.pdTypeName = genericDTO.PDTypeName;
        type.principalName = genericDTO.PrincipalName;
        type.returnType = genericDTO.ReturnType;
        type.returnValue = genericDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(genericDTO.Status);
        type.touchedMembers = [];

        if (genericDTO.TouchedMembers != null) {
            for (let i59 in genericDTO.TouchedMembers) {
                if(genericDTO.TouchedMembers.hasOwnProperty(i59)) {
                    type.touchedMembers.push(genericDTO.TouchedMembers[i59]);
                }
            }
        }

        type.values = {};

        if (genericDTO.Values != null) {
            for (let i60 in genericDTO.Values) {
                if (genericDTO.Values.hasOwnProperty(i60)) {
                    type.values[i60] = genericDTO.Values[i60];
                }
            }
        }

        return type;
    }

    public static detailViewContextDTO(detailViewContextDTO: any): any {
        let type: any = {};

        type._type = 'detailViewContextDTO';
        type.assoziationGridIterators = {};

        if (detailViewContextDTO.AssoziationGridIterators != null) {
            for (let i51 in detailViewContextDTO.AssoziationGridIterators) {
                if (detailViewContextDTO.AssoziationGridIterators.hasOwnProperty(i51)) {
                    type.assoziationGridIterators[i51] = RADGeneratedModels.iteratorDTO(detailViewContextDTO.AssoziationGridIterators[i51]);
                }
            }
        }

        type.contextParameters = {};

        if (detailViewContextDTO.ContextParameters != null) {
            for (let i54 in detailViewContextDTO.ContextParameters) {
                if (detailViewContextDTO.ContextParameters.hasOwnProperty(i54)) {
                    type.contextParameters[i54] = detailViewContextDTO.ContextParameters[i54];
                }
            }
        }

        if (detailViewContextDTO.DetailView != null) {
            let typeName = 'detailViewDTO';
            type.detailView = RADGeneratedModels[typeName](detailViewContextDTO.DetailView);
        } else {
            type.detailView = null;
        }

        type.errorInformation = {};

        if (detailViewContextDTO.ErrorInformation != null) {
            for (let i55 in detailViewContextDTO.ErrorInformation) {
                if (detailViewContextDTO.ErrorInformation.hasOwnProperty(i55)) {
                    type.errorInformation[i55] = detailViewContextDTO.ErrorInformation[i55];
                }
            }
        }

        type.errorMessage = detailViewContextDTO.ErrorMessage;
        type.hasWriteRight = detailViewContextDTO.HasWriteRight;
        type.id = detailViewContextDTO.ID;
        type.isModified = detailViewContextDTO.IsModified;
        type.isNested = detailViewContextDTO.IsNested;
        type.isNewObject = detailViewContextDTO.IsNewObject;
        type.lockAquired = detailViewContextDTO.LockAquired;
        type.lockedByUser = detailViewContextDTO.LockedByUser;
        type.lockedObjectIdent = detailViewContextDTO.LockedObjectIdent;
        type.lockGroupID = detailViewContextDTO.LockGroupID;
        type.nestedDetailViewContexts = {};

        if (detailViewContextDTO.NestedDetailViewContexts != null) {
            for (let i56 in detailViewContextDTO.NestedDetailViewContexts) {
                if (detailViewContextDTO.NestedDetailViewContexts.hasOwnProperty(i56)) {
                    type.nestedDetailViewContexts[i56] = RADGeneratedModels.detailViewContextDTO(detailViewContextDTO.NestedDetailViewContexts[i56]);
                }
            }
        }

        type.persistenceContextID = detailViewContextDTO.PersistenceContextID;
        type.previousPDOID = detailViewContextDTO.PreviousPDOID;
        type.previousTypeName = detailViewContextDTO.PreviousTypeName;
        type.publicUserData = {};

        if (detailViewContextDTO.PublicUserData != null) {
            for (let i57 in detailViewContextDTO.PublicUserData) {
                if (detailViewContextDTO.PublicUserData.hasOwnProperty(i57)) {
                    type.publicUserData[i57] = detailViewContextDTO.PublicUserData[i57];
                }
            }
        }

        type.relationNameFromPreviousObject = detailViewContextDTO.RelationNameFromPreviousObject;
        type.returnType = detailViewContextDTO.ReturnType;
        type.returnValue = detailViewContextDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(detailViewContextDTO.Status);
        if (detailViewContextDTO.Subject != null) {
            let typeName = 'genericDTO';
            type.subject = RADGeneratedModels[typeName](detailViewContextDTO.Subject);
        } else {
            type.subject = null;
        }

        type.touchedMembers = [];

        if (detailViewContextDTO.TouchedMembers != null) {
            for (let i61 in detailViewContextDTO.TouchedMembers) {
                if(detailViewContextDTO.TouchedMembers.hasOwnProperty(i61)) {
                    type.touchedMembers.push(detailViewContextDTO.TouchedMembers[i61]);
                }
            }
        }

        return type;
    }

    public static imageSpriteDTO(imageSpriteDTO: any): any {
        let type: any = {};

        type._type = 'imageSpriteDTO';
        type.errorInformation = {};

        if (imageSpriteDTO.ErrorInformation != null) {
            for (let i62 in imageSpriteDTO.ErrorInformation) {
                if (imageSpriteDTO.ErrorInformation.hasOwnProperty(i62)) {
                    type.errorInformation[i62] = imageSpriteDTO.ErrorInformation[i62];
                }
            }
        }

        type.errorMessage = imageSpriteDTO.ErrorMessage;
        type.imageMap = {};

        if (imageSpriteDTO.ImageMap != null) {
            for (let i63 in imageSpriteDTO.ImageMap) {
                if (imageSpriteDTO.ImageMap.hasOwnProperty(i63)) {
                    type.imageMap[i63] = imageSpriteDTO.ImageMap[i63];
                }
            }
        }

        type.isModified = imageSpriteDTO.IsModified;
        type.returnType = imageSpriteDTO.ReturnType;
        type.returnValue = imageSpriteDTO.ReturnValue;
        type.spriteURL = imageSpriteDTO.SpriteURL;
        type.status = RADGeneratedModels.statusEnumDTO(imageSpriteDTO.Status);
        type.svgMap = {};

        if (imageSpriteDTO.SvgMap != null) {
            for (let i64 in imageSpriteDTO.SvgMap) {
                if (imageSpriteDTO.SvgMap.hasOwnProperty(i64)) {
                    type.svgMap[i64] = imageSpriteDTO.SvgMap[i64];
                }
            }
        }

        type.touchedMembers = [];

        if (imageSpriteDTO.TouchedMembers != null) {
            for (let i65 in imageSpriteDTO.TouchedMembers) {
                if(imageSpriteDTO.TouchedMembers.hasOwnProperty(i65)) {
                    type.touchedMembers.push(imageSpriteDTO.TouchedMembers[i65]);
                }
            }
        }

        return type;
    }

    public static inlineEditingContextDataDTO(inlineEditingContextDataDTO: any): any {
        let type: any = {};

        type._type = 'inlineEditingContextDataDTO';
        type.errorInformation = {};

        if (inlineEditingContextDataDTO.ErrorInformation != null) {
            for (let i66 in inlineEditingContextDataDTO.ErrorInformation) {
                if (inlineEditingContextDataDTO.ErrorInformation.hasOwnProperty(i66)) {
                    type.errorInformation[i66] = inlineEditingContextDataDTO.ErrorInformation[i66];
                }
            }
        }

        type.errorMessage = inlineEditingContextDataDTO.ErrorMessage;
        type.isModified = inlineEditingContextDataDTO.IsModified;
        type.returnType = inlineEditingContextDataDTO.ReturnType;
        type.returnValue = inlineEditingContextDataDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(inlineEditingContextDataDTO.Status);
        type.subjectLocks = {};

        if (inlineEditingContextDataDTO.SubjectLocks != null) {
            for (let i67 in inlineEditingContextDataDTO.SubjectLocks) {
                if (inlineEditingContextDataDTO.SubjectLocks.hasOwnProperty(i67)) {
                    type.subjectLocks[i67] = inlineEditingContextDataDTO.SubjectLocks[i67];
                }
            }
        }

        type.subjects = [];

        if (inlineEditingContextDataDTO.Subjects != null) {
            for (let i68 in inlineEditingContextDataDTO.Subjects) {
                if(inlineEditingContextDataDTO.Subjects.hasOwnProperty(i68)) {
                     let typeName = 'genericDTO';
                     type.subjects.push(RADGeneratedModels[typeName](inlineEditingContextDataDTO.Subjects[i68]));
                }
            }
        }

        type.touchedMembers = [];

        if (inlineEditingContextDataDTO.TouchedMembers != null) {
            for (let i69 in inlineEditingContextDataDTO.TouchedMembers) {
                if(inlineEditingContextDataDTO.TouchedMembers.hasOwnProperty(i69)) {
                    type.touchedMembers.push(inlineEditingContextDataDTO.TouchedMembers[i69]);
                }
            }
        }

        return type;
    }

    public static inlineEditingContextDTO(inlineEditingContextDTO: any): any {
        let type: any = {};

        type._type = 'inlineEditingContextDTO';
        type.contextObjectPdoId = inlineEditingContextDTO.ContextObjectPdoId;
        type.contextObjectPdTypeName = inlineEditingContextDTO.ContextObjectPdTypeName;
        type.contextRelationName = inlineEditingContextDTO.ContextRelationName;
        if (inlineEditingContextDTO.DetailView != null) {
            let typeName = 'detailViewDTO';
            type.detailView = RADGeneratedModels[typeName](inlineEditingContextDTO.DetailView);
        } else {
            type.detailView = null;
        }

        type.detailViewContextID = inlineEditingContextDTO.DetailViewContextID;
        type.errorInformation = {};

        if (inlineEditingContextDTO.ErrorInformation != null) {
            for (let i70 in inlineEditingContextDTO.ErrorInformation) {
                if (inlineEditingContextDTO.ErrorInformation.hasOwnProperty(i70)) {
                    type.errorInformation[i70] = inlineEditingContextDTO.ErrorInformation[i70];
                }
            }
        }

        type.errorMessage = inlineEditingContextDTO.ErrorMessage;
        type.hasCreateRight = inlineEditingContextDTO.HasCreateRight;
        type.hasWriteRight = inlineEditingContextDTO.HasWriteRight;
        type.id = inlineEditingContextDTO.ID;
        type.isModified = inlineEditingContextDTO.IsModified;
        type.lockGroupID = inlineEditingContextDTO.LockGroupID;
        type.persistenceContextID = inlineEditingContextDTO.PersistenceContextID;
        type.primarySubAssociation = inlineEditingContextDTO.PrimarySubAssociation;
        if (inlineEditingContextDTO.PrimarySubAssociationListView != null) {
            let typeName = 'listViewDTO';
            type.primarySubAssociationListView = RADGeneratedModels[typeName](inlineEditingContextDTO.PrimarySubAssociationListView);
        } else {
            type.primarySubAssociationListView = null;
        }

        type.properties = [];

        if (inlineEditingContextDTO.Properties != null) {
            for (let i71 in inlineEditingContextDTO.Properties) {
                if(inlineEditingContextDTO.Properties.hasOwnProperty(i71)) {
                    type.properties.push(inlineEditingContextDTO.Properties[i71]);
                }
            }
        }

        type.returnType = inlineEditingContextDTO.ReturnType;
        type.returnValue = inlineEditingContextDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(inlineEditingContextDTO.Status);
        type.toManyAssociations = [];

        if (inlineEditingContextDTO.ToManyAssociations != null) {
            for (let i72 in inlineEditingContextDTO.ToManyAssociations) {
                if(inlineEditingContextDTO.ToManyAssociations.hasOwnProperty(i72)) {
                    type.toManyAssociations.push(inlineEditingContextDTO.ToManyAssociations[i72]);
                }
            }
        }

        type.touchedMembers = [];

        if (inlineEditingContextDTO.TouchedMembers != null) {
            for (let i73 in inlineEditingContextDTO.TouchedMembers) {
                if(inlineEditingContextDTO.TouchedMembers.hasOwnProperty(i73)) {
                    type.touchedMembers.push(inlineEditingContextDTO.TouchedMembers[i73]);
                }
            }
        }

        return type;
    }

    public static operationResultDTO(operationResultDTO: any): any {
        let type: any = {};

        type._type = 'operationResultDTO';
        type.contextParameters = {};

        if (operationResultDTO.ContextParameters != null) {
            for (let i77 in operationResultDTO.ContextParameters) {
                if (operationResultDTO.ContextParameters.hasOwnProperty(i77)) {
                    type.contextParameters[i77] = operationResultDTO.ContextParameters[i77];
                }
            }
        }

        type.errorInformation = {};

        if (operationResultDTO.ErrorInformation != null) {
            for (let i78 in operationResultDTO.ErrorInformation) {
                if (operationResultDTO.ErrorInformation.hasOwnProperty(i78)) {
                    type.errorInformation[i78] = operationResultDTO.ErrorInformation[i78];
                }
            }
        }

        type.errorMessage = operationResultDTO.ErrorMessage;
        type.isModified = operationResultDTO.IsModified;
        type.isValid = operationResultDTO.IsValid;
        type.returnType = operationResultDTO.ReturnType;
        type.returnValue = operationResultDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(operationResultDTO.Status);
        if (operationResultDTO.Subject != null) {
            let typeName = 'genericDTO';
            type.subject = RADGeneratedModels[typeName](operationResultDTO.Subject);
        } else {
            type.subject = null;
        }

        type.touchedMembers = [];

        if (operationResultDTO.TouchedMembers != null) {
            for (let i79 in operationResultDTO.TouchedMembers) {
                if(operationResultDTO.TouchedMembers.hasOwnProperty(i79)) {
                    type.touchedMembers.push(operationResultDTO.TouchedMembers[i79]);
                }
            }
        }

        type.validationMessages = {};

        if (operationResultDTO.ValidationMessages != null) {
            for (let i80 in operationResultDTO.ValidationMessages) {
                if (operationResultDTO.ValidationMessages.hasOwnProperty(i80)) {
                    type.validationMessages[i80] = operationResultDTO.ValidationMessages[i80];
                }
            }
        }

        return type;
    }

    public static saveResultDTO(saveResultDTO: any): any {
        let type: any = {};

        type._type = 'saveResultDTO';
        type.errorInformation = {};

        if (saveResultDTO.ErrorInformation != null) {
            for (let i81 in saveResultDTO.ErrorInformation) {
                if (saveResultDTO.ErrorInformation.hasOwnProperty(i81)) {
                    type.errorInformation[i81] = saveResultDTO.ErrorInformation[i81];
                }
            }
        }

        type.errorMessage = saveResultDTO.ErrorMessage;
        type.isModified = saveResultDTO.IsModified;
        type.isValid = saveResultDTO.IsValid;
        type.returnType = saveResultDTO.ReturnType;
        type.returnValue = saveResultDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(saveResultDTO.Status);
        type.touchedMembers = [];

        if (saveResultDTO.TouchedMembers != null) {
            for (let i82 in saveResultDTO.TouchedMembers) {
                if(saveResultDTO.TouchedMembers.hasOwnProperty(i82)) {
                    type.touchedMembers.push(saveResultDTO.TouchedMembers[i82]);
                }
            }
        }

        type.validationMessages = {};

        if (saveResultDTO.ValidationMessages != null) {
            for (let i83 in saveResultDTO.ValidationMessages) {
                if (saveResultDTO.ValidationMessages.hasOwnProperty(i83)) {
                    type.validationMessages[i83] = saveResultDTO.ValidationMessages[i83];
                }
            }
        }

        return type;
    }

    public static updateDTO(updateDTO: any): any {
        let type: any = {};

        type._type = 'updateDTO';
        type.errorInformation = {};

        if (updateDTO.ErrorInformation != null) {
            for (let i84 in updateDTO.ErrorInformation) {
                if (updateDTO.ErrorInformation.hasOwnProperty(i84)) {
                    type.errorInformation[i84] = updateDTO.ErrorInformation[i84];
                }
            }
        }

        type.errorMessage = updateDTO.ErrorMessage;
        type.isModified = updateDTO.IsModified;
        type.isValid = updateDTO.IsValid;
        type.refreshProperties = {};

        if (updateDTO.RefreshProperties != null) {
            for (let i85 in updateDTO.RefreshProperties) {
                if (updateDTO.RefreshProperties.hasOwnProperty(i85)) {
                    type.refreshProperties[i85] = updateDTO.RefreshProperties[i85];
                }
            }
        }

        type.returnType = updateDTO.ReturnType;
        type.returnValue = updateDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(updateDTO.Status);
        type.touchedMembers = [];

        if (updateDTO.TouchedMembers != null) {
            for (let i86 in updateDTO.TouchedMembers) {
                if(updateDTO.TouchedMembers.hasOwnProperty(i86)) {
                    type.touchedMembers.push(updateDTO.TouchedMembers[i86]);
                }
            }
        }

        type.validationMessages = {};

        if (updateDTO.ValidationMessages != null) {
            for (let i87 in updateDTO.ValidationMessages) {
                if (updateDTO.ValidationMessages.hasOwnProperty(i87)) {
                    type.validationMessages[i87] = updateDTO.ValidationMessages[i87];
                }
            }
        }

        return type;
    }

    public static validationDTO(validationDTO: any): any {
        let type: any = {};

        type._type = 'validationDTO';
        type.errorInformation = {};

        if (validationDTO.ErrorInformation != null) {
            for (let i74 in validationDTO.ErrorInformation) {
                if (validationDTO.ErrorInformation.hasOwnProperty(i74)) {
                    type.errorInformation[i74] = validationDTO.ErrorInformation[i74];
                }
            }
        }

        type.errorMessage = validationDTO.ErrorMessage;
        type.isModified = validationDTO.IsModified;
        type.isValid = validationDTO.IsValid;
        type.returnType = validationDTO.ReturnType;
        type.returnValue = validationDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(validationDTO.Status);
        type.touchedMembers = [];

        if (validationDTO.TouchedMembers != null) {
            for (let i75 in validationDTO.TouchedMembers) {
                if(validationDTO.TouchedMembers.hasOwnProperty(i75)) {
                    type.touchedMembers.push(validationDTO.TouchedMembers[i75]);
                }
            }
        }

        type.validationMessages = {};

        if (validationDTO.ValidationMessages != null) {
            for (let i76 in validationDTO.ValidationMessages) {
                if (validationDTO.ValidationMessages.hasOwnProperty(i76)) {
                    type.validationMessages[i76] = validationDTO.ValidationMessages[i76];
                }
            }
        }

        return type;
    }

    public static searchSuggestionsDTO(searchSuggestionsDTO: any): any {
        let type: any = {};

        type._type = 'searchSuggestionsDTO';
        type.errorInformation = {};

        if (searchSuggestionsDTO.ErrorInformation != null) {
            for (let i92 in searchSuggestionsDTO.ErrorInformation) {
                if (searchSuggestionsDTO.ErrorInformation.hasOwnProperty(i92)) {
                    type.errorInformation[i92] = searchSuggestionsDTO.ErrorInformation[i92];
                }
            }
        }

        type.errorMessage = searchSuggestionsDTO.ErrorMessage;
        type.isModified = searchSuggestionsDTO.IsModified;
        type.returnType = searchSuggestionsDTO.ReturnType;
        type.returnValue = searchSuggestionsDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(searchSuggestionsDTO.Status);
        type.suggestions = [];

        if (searchSuggestionsDTO.Suggestions != null) {
            for (let i93 in searchSuggestionsDTO.Suggestions) {
                if(searchSuggestionsDTO.Suggestions.hasOwnProperty(i93)) {
                    type.suggestions.push(searchSuggestionsDTO.Suggestions[i93]);
                }
            }
        }

        type.touchedMembers = [];

        if (searchSuggestionsDTO.TouchedMembers != null) {
            for (let i94 in searchSuggestionsDTO.TouchedMembers) {
                if(searchSuggestionsDTO.TouchedMembers.hasOwnProperty(i94)) {
                    type.touchedMembers.push(searchSuggestionsDTO.TouchedMembers[i94]);
                }
            }
        }

        return type;
    }

    public static historizationPointDTO(historizationPointDTO: any): any {
        let type: any = {};

        type._type = 'historizationPointDTO';
        type.historizationDate = historizationPointDTO.HistorizationDate;
        type.pdoId = historizationPointDTO.PDO_ID;
        type.title = historizationPointDTO.Title;
        return type;
    }

    public static historyInformationDTO(historyInformationDTO: any): any {
        let type: any = {};

        type._type = 'historyInformationDTO';
        type.historizableObjectPDOID = historyInformationDTO.HistorizableObjectPDO_ID;
        if (historyInformationDTO.HistoryDate != null) {
            let typeName = 'historizationPointDTO';
            type.historyDate = RADGeneratedModels[typeName](historyInformationDTO.HistoryDate);
        } else {
            type.historyDate = null;
        }

        return type;
    }

    public static objectHistoryInformationsDTO(objectHistoryInformationsDTO: any): any {
        let type: any = {};

        type._type = 'objectHistoryInformationsDTO';
        type.errorInformation = {};

        if (objectHistoryInformationsDTO.ErrorInformation != null) {
            for (let i96 in objectHistoryInformationsDTO.ErrorInformation) {
                if (objectHistoryInformationsDTO.ErrorInformation.hasOwnProperty(i96)) {
                    type.errorInformation[i96] = objectHistoryInformationsDTO.ErrorInformation[i96];
                }
            }
        }

        type.errorMessage = objectHistoryInformationsDTO.ErrorMessage;
        type.historyInformation = [];

        if (objectHistoryInformationsDTO.HistoryInformation != null) {
            for (let i97 in objectHistoryInformationsDTO.HistoryInformation) {
                if(objectHistoryInformationsDTO.HistoryInformation.hasOwnProperty(i97)) {
                     let typeName = 'historyInformationDTO';
                     type.historyInformation.push(RADGeneratedModels[typeName](objectHistoryInformationsDTO.HistoryInformation[i97]));
                }
            }
        }

        type.isCurrentDeleted = objectHistoryInformationsDTO.IsCurrentDeleted;
        type.isHistorizableType = objectHistoryInformationsDTO.IsHistorizableType;
        type.isModified = objectHistoryInformationsDTO.IsModified;
        type.isTargetHistoryObject = objectHistoryInformationsDTO.IsTargetHistoryObject;
        type.returnType = objectHistoryInformationsDTO.ReturnType;
        type.returnValue = objectHistoryInformationsDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(objectHistoryInformationsDTO.Status);
        type.targetHistoriziationPointPdoID = objectHistoryInformationsDTO.TargetHistoriziationPointPdoID;
        type.touchedMembers = [];

        if (objectHistoryInformationsDTO.TouchedMembers != null) {
            for (let i98 in objectHistoryInformationsDTO.TouchedMembers) {
                if(objectHistoryInformationsDTO.TouchedMembers.hasOwnProperty(i98)) {
                    type.touchedMembers.push(objectHistoryInformationsDTO.TouchedMembers[i98]);
                }
            }
        }

        return type;
    }

    public static summaryViewContextDTO(summaryViewContextDTO: any): any {
        let type: any = {};

        type._type = 'summaryViewContextDTO';
        if (summaryViewContextDTO.DetailViewContext != null) {
            let typeName = 'detailViewContextDTO';
            type.detailViewContext = RADGeneratedModels[typeName](summaryViewContextDTO.DetailViewContext);
        } else {
            type.detailViewContext = null;
        }

        type.errorInformation = {};

        if (summaryViewContextDTO.ErrorInformation != null) {
            for (let i95 in summaryViewContextDTO.ErrorInformation) {
                if (summaryViewContextDTO.ErrorInformation.hasOwnProperty(i95)) {
                    type.errorInformation[i95] = summaryViewContextDTO.ErrorInformation[i95];
                }
            }
        }

        type.errorMessage = summaryViewContextDTO.ErrorMessage;
        type.isModified = summaryViewContextDTO.IsModified;
        type.isSummaryViewActive = summaryViewContextDTO.IsSummaryViewActive;
        if (summaryViewContextDTO.ObjectHistoryInformations != null) {
            let typeName = 'objectHistoryInformationsDTO';
            type.objectHistoryInformations = RADGeneratedModels[typeName](summaryViewContextDTO.ObjectHistoryInformations);
        } else {
            type.objectHistoryInformations = null;
        }

        type.returnType = summaryViewContextDTO.ReturnType;
        type.returnValue = summaryViewContextDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(summaryViewContextDTO.Status);
        type.touchedMembers = [];

        if (summaryViewContextDTO.TouchedMembers != null) {
            for (let i99 in summaryViewContextDTO.TouchedMembers) {
                if(summaryViewContextDTO.TouchedMembers.hasOwnProperty(i99)) {
                    type.touchedMembers.push(summaryViewContextDTO.TouchedMembers[i99]);
                }
            }
        }

        return type;
    }

    public static tryDeletionDTO(tryDeletionDTO: any): any {
        let type: any = {};

        type._type = 'tryDeletionDTO';
        type.errorInformation = {};

        if (tryDeletionDTO.ErrorInformation != null) {
            for (let i100 in tryDeletionDTO.ErrorInformation) {
                if (tryDeletionDTO.ErrorInformation.hasOwnProperty(i100)) {
                    type.errorInformation[i100] = tryDeletionDTO.ErrorInformation[i100];
                }
            }
        }

        type.errorMessage = tryDeletionDTO.ErrorMessage;
        type.isModified = tryDeletionDTO.IsModified;
        type.objectsToDelete = [];

        if (tryDeletionDTO.ObjectsToDelete != null) {
            for (let i101 in tryDeletionDTO.ObjectsToDelete) {
                if(tryDeletionDTO.ObjectsToDelete.hasOwnProperty(i101)) {
                     let typeName = 'deletionItemDTO';
                     type.objectsToDelete.push(RADGeneratedModels[typeName](tryDeletionDTO.ObjectsToDelete[i101]));
                }
            }
        }

        type.returnType = tryDeletionDTO.ReturnType;
        type.returnValue = tryDeletionDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(tryDeletionDTO.Status);
        type.touchedMembers = [];

        if (tryDeletionDTO.TouchedMembers != null) {
            for (let i102 in tryDeletionDTO.TouchedMembers) {
                if(tryDeletionDTO.TouchedMembers.hasOwnProperty(i102)) {
                    type.touchedMembers.push(tryDeletionDTO.TouchedMembers[i102]);
                }
            }
        }

        return type;
    }

    public static updateAndValidateDTO(updateAndValidateDTO: any): any {
        let type: any = {};

        type._type = 'updateAndValidateDTO';
        type.errorInformation = {};

        if (updateAndValidateDTO.ErrorInformation != null) {
            for (let i103 in updateAndValidateDTO.ErrorInformation) {
                if (updateAndValidateDTO.ErrorInformation.hasOwnProperty(i103)) {
                    type.errorInformation[i103] = updateAndValidateDTO.ErrorInformation[i103];
                }
            }
        }

        type.errorMessage = updateAndValidateDTO.ErrorMessage;
        type.isModified = updateAndValidateDTO.IsModified;
        type.returnType = updateAndValidateDTO.ReturnType;
        type.returnValue = updateAndValidateDTO.ReturnValue;
        if (updateAndValidateDTO.SaveResultDTO != null) {
            let typeName = 'saveResultDTO';
            type.saveResultDTO = RADGeneratedModels[typeName](updateAndValidateDTO.SaveResultDTO);
        } else {
            type.saveResultDTO = null;
        }

        type.status = RADGeneratedModels.statusEnumDTO(updateAndValidateDTO.Status);
        type.touchedMembers = [];

        if (updateAndValidateDTO.TouchedMembers != null) {
            for (let i104 in updateAndValidateDTO.TouchedMembers) {
                if(updateAndValidateDTO.TouchedMembers.hasOwnProperty(i104)) {
                    type.touchedMembers.push(updateAndValidateDTO.TouchedMembers[i104]);
                }
            }
        }

        if (updateAndValidateDTO.UpdateDTO != null) {
            let typeName = 'updateDTO';
            type.updateDTO = RADGeneratedModels[typeName](updateAndValidateDTO.UpdateDTO);
        } else {
            type.updateDTO = null;
        }

        return type;
    }

    public static resultDTO(resultDTO: any): any {
        let type: any = {};

        type._type = 'resultDTO';
        type.errorInformation = {};

        if (resultDTO.ErrorInformation != null) {
            for (let i1 in resultDTO.ErrorInformation) {
                if (resultDTO.ErrorInformation.hasOwnProperty(i1)) {
                    type.errorInformation[i1] = resultDTO.ErrorInformation[i1];
                }
            }
        }

        type.errorMessage = resultDTO.ErrorMessage;
        type.isModified = resultDTO.IsModified;
        type.returnType = resultDTO.ReturnType;
        type.returnValue = resultDTO.ReturnValue;
        type.status = RADGeneratedModels.statusEnumDTO(resultDTO.Status);
        type.touchedMembers = [];

        if (resultDTO.TouchedMembers != null) {
            for (let i2 in resultDTO.TouchedMembers) {
                if(resultDTO.TouchedMembers.hasOwnProperty(i2)) {
                    type.touchedMembers.push(resultDTO.TouchedMembers[i2]);
                }
            }
        }

        return type;
    }

    public static changePasswordResponseDTO(changePasswordResponseDTO: any): any {
        let type: any = {};

        type._type = 'changePasswordResponseDTO';
        type.isUserLocked = changePasswordResponseDTO.IsUserLocked;
        type.messages = [];

        if (changePasswordResponseDTO.Messages != null) {
            for (let i108 in changePasswordResponseDTO.Messages) {
                if(changePasswordResponseDTO.Messages.hasOwnProperty(i108)) {
                    type.messages.push(changePasswordResponseDTO.Messages[i108]);
                }
            }
        }

        type.successfull = changePasswordResponseDTO.Successfull;
        type.twoFATokenNeeded = changePasswordResponseDTO.TwoFATokenNeeded;
        return type;
    }

    public static hideConnectedElementsRequestDTO(hideConnectedElementsRequestDTO: any): any {
        let type: any = {};

        type._type = 'hideConnectedElementsRequestDTO';
        type.associationName = hideConnectedElementsRequestDTO.AssociationName;
        type.hide = hideConnectedElementsRequestDTO.Hide;
        return type;
    }

    public static searchObjectPositionRequestDTO(searchObjectPositionRequestDTO: any): any {
        let type: any = {};

        type._type = 'searchObjectPositionRequestDTO';
        type.currentPagingSize = searchObjectPositionRequestDTO.CurrentPagingSize;
        type.pdoIDToFind = searchObjectPositionRequestDTO.PdoIDToFind;
        return type;
    }

    public static pdIteratorOperatorDTO(pdIteratorOperatorDTO: any): any {
        let type: any = {};

        type._type = 'pdIteratorOperatorDTO';
        type.disablePrincipalFilter = pdIteratorOperatorDTO.DisablePrincipalFilter;
        if (pdIteratorOperatorDTO.HideConnectedElementsRequest != null) {
            let typeName = 'hideConnectedElementsRequestDTO';
            type.hideConnectedElementsRequest = RADGeneratedModels[typeName](pdIteratorOperatorDTO.HideConnectedElementsRequest);
        } else {
            type.hideConnectedElementsRequest = null;
        }

        type.historizationDates = [];

        if (pdIteratorOperatorDTO.HistorizationDates != null) {
            for (let i109 in pdIteratorOperatorDTO.HistorizationDates) {
                if(pdIteratorOperatorDTO.HistorizationDates.hasOwnProperty(i109)) {
                    type.historizationDates.push(pdIteratorOperatorDTO.HistorizationDates[i109]);
                }
            }
        }

        type.includeAllPrincipals = pdIteratorOperatorDTO.IncludeAllPrincipals;
        type.includeBasePrincipals = pdIteratorOperatorDTO.IncludeBasePrincipals;
        type.includePrincipalFromSubject = pdIteratorOperatorDTO.IncludePrincipalFromSubject;
        type.includeSubPrincipals = pdIteratorOperatorDTO.IncludeSubPrincipals;
        type.isGridIterator = pdIteratorOperatorDTO.IsGridIterator;
        type.memoryOptimizationEnabled = pdIteratorOperatorDTO.MemoryOptimizationEnabled;
        type.onlySubPrincipals = pdIteratorOperatorDTO.OnlySubPrincipals;
        type.principalFilter = pdIteratorOperatorDTO.PrincipalFilter;
        if (pdIteratorOperatorDTO.SearchObjectPositionRequest != null) {
            let typeName = 'searchObjectPositionRequestDTO';
            type.searchObjectPositionRequest = RADGeneratedModels[typeName](pdIteratorOperatorDTO.SearchObjectPositionRequest);
        } else {
            type.searchObjectPositionRequest = null;
        }

        type.showCurrentObjects = pdIteratorOperatorDTO.ShowCurrentObjects;
        type.showHistoricedObjects = pdIteratorOperatorDTO.ShowHistoricedObjects;
        type.showObjectsWithoutPrincipal = pdIteratorOperatorDTO.ShowObjectsWithoutPrincipal;
        type.visibleDeletedObjects = [];

        if (pdIteratorOperatorDTO.VisibleDeletedObjects != null) {
            for (let i110 in pdIteratorOperatorDTO.VisibleDeletedObjects) {
                if(pdIteratorOperatorDTO.VisibleDeletedObjects.hasOwnProperty(i110)) {
                    type.visibleDeletedObjects.push(pdIteratorOperatorDTO.VisibleDeletedObjects[i110]);
                }
            }
        }

        return type;
    }

    public static exportType(index: string) {
        let values = [];

        values.push('XLS');
        values.push('CSV');
        values.push('PDF');

        return values[index];
    }

    public static groupPropertyDTO(groupPropertyDTO: any): any {
        let type: any = {};

        type._type = 'groupPropertyDTO';
        type.expression = groupPropertyDTO.Expression;
        type.propertyName = groupPropertyDTO.PropertyName;
        return type;
    }

    public static aggregatePropertyDTO(aggregatePropertyDTO: any): any {
        let type: any = {};

        type._type = 'aggregatePropertyDTO';
        type.distinct = aggregatePropertyDTO.Distinct;
        type.function = aggregatePropertyDTO.Function;
        type.propertyName = aggregatePropertyDTO.PropertyName;
        return type;
    }

    public static iteratorAggregationDTO(iteratorAggregationDTO: any): any {
        let type: any = {};

        type._type = 'iteratorAggregationDTO';
        type.groupProperties = [];

        if (iteratorAggregationDTO.GroupProperties != null) {
            for (let i111 in iteratorAggregationDTO.GroupProperties) {
                if(iteratorAggregationDTO.GroupProperties.hasOwnProperty(i111)) {
                     let typeName = 'groupPropertyDTO';
                     type.groupProperties.push(RADGeneratedModels[typeName](iteratorAggregationDTO.GroupProperties[i111]));
                }
            }
        }

        type.properties = [];

        if (iteratorAggregationDTO.Properties != null) {
            for (let i112 in iteratorAggregationDTO.Properties) {
                if(iteratorAggregationDTO.Properties.hasOwnProperty(i112)) {
                     let typeName = 'aggregatePropertyDTO';
                     type.properties.push(RADGeneratedModels[typeName](iteratorAggregationDTO.Properties[i112]));
                }
            }
        }

        return type;
    }

    public static assignedPrincipalsDTO(assignedPrincipalsDTO: any): any {
        let type: any = {};

        type._type = 'assignedPrincipalsDTO';
        type.assignedPrincipals = [];

        if (assignedPrincipalsDTO.AssignedPrincipals != null) {
            for (let i113 in assignedPrincipalsDTO.AssignedPrincipals) {
                if(assignedPrincipalsDTO.AssignedPrincipals.hasOwnProperty(i113)) {
                     let typeName = 'principalDTO';
                     type.assignedPrincipals.push(RADGeneratedModels[typeName](assignedPrincipalsDTO.AssignedPrincipals[i113]));
                }
            }
        }

        return type;
    }

    public static searchParameterDTO(searchParameterDTO: any): any {
        let type: any = {};

        type._type = 'searchParameterDTO';
        type.extensionModules = [];

        if (searchParameterDTO.ExtensionModules != null) {
            for (let i114 in searchParameterDTO.ExtensionModules) {
                if(searchParameterDTO.ExtensionModules.hasOwnProperty(i114)) {
                     let typeName = 'extensionModuleDTO';
                     type.extensionModules.push(RADGeneratedModels[typeName](searchParameterDTO.ExtensionModules[i114]));
                }
            }
        }

        type.historizationPoints = [];

        if (searchParameterDTO.HistorizationPoints != null) {
            for (let i115 in searchParameterDTO.HistorizationPoints) {
                if(searchParameterDTO.HistorizationPoints.hasOwnProperty(i115)) {
                     let typeName = 'historizationPointDTO';
                     type.historizationPoints.push(RADGeneratedModels[typeName](searchParameterDTO.HistorizationPoints[i115]));
                }
            }
        }

        return type;
    }

    public static tasksForTypeDTO(tasksForTypeDTO: any): any {
        let type: any = {};

        type._type = 'tasksForTypeDTO';
        type.count = tasksForTypeDTO.Count;
        type.ergNamePluralized = tasksForTypeDTO.ErgNamePluralized;
        type.pdTypeId = tasksForTypeDTO.PDTypeId;
        type.pdTypeName = tasksForTypeDTO.PDTypeName;
        return type;
    }

    public static taskInformationDTO(taskInformationDTO: any): any {
        let type: any = {};

        type._type = 'taskInformationDTO';
        type.allAssignedTasks = [];

        if (taskInformationDTO.AllAssignedTasks != null) {
            for (let i116 in taskInformationDTO.AllAssignedTasks) {
                if(taskInformationDTO.AllAssignedTasks.hasOwnProperty(i116)) {
                     let typeName = 'tasksForTypeDTO';
                     type.allAssignedTasks.push(RADGeneratedModels[typeName](taskInformationDTO.AllAssignedTasks[i116]));
                }
            }
        }

        type.allTasks = [];

        if (taskInformationDTO.AllTasks != null) {
            for (let i117 in taskInformationDTO.AllTasks) {
                if(taskInformationDTO.AllTasks.hasOwnProperty(i117)) {
                     let typeName = 'tasksForTypeDTO';
                     type.allTasks.push(RADGeneratedModels[typeName](taskInformationDTO.AllTasks[i117]));
                }
            }
        }

        type.allUnassignedTasks = [];

        if (taskInformationDTO.AllUnassignedTasks != null) {
            for (let i118 in taskInformationDTO.AllUnassignedTasks) {
                if(taskInformationDTO.AllUnassignedTasks.hasOwnProperty(i118)) {
                     let typeName = 'tasksForTypeDTO';
                     type.allUnassignedTasks.push(RADGeneratedModels[typeName](taskInformationDTO.AllUnassignedTasks[i118]));
                }
            }
        }

        type.taskListViewId = taskInformationDTO.TaskListViewId;
        return type;
    }

    public static systemLockNotificationDTO(systemLockNotificationDTO: any): any {
        let type: any = {};

        type._type = 'systemLockNotificationDTO';
        type.isTransient = systemLockNotificationDTO.IsTransient;
        type.isUserOnExceptionList = systemLockNotificationDTO.IsUserOnExceptionList;
        type.lockEnd = systemLockNotificationDTO.LockEnd;
        type.lockStart = systemLockNotificationDTO.LockStart;
        type.notificationPDOID = systemLockNotificationDTO.Notification_PDOID;
        type.notificationMessage = systemLockNotificationDTO.NotificationMessage;
        type.preNotification = systemLockNotificationDTO.PreNotification;
        return type;
    }

    public static notificationDTO(notificationDTO: any): any {
        let type: any = {};

        type._type = 'notificationDTO';
        type.isTransient = notificationDTO.IsTransient;
        type.notificationPDOID = notificationDTO.Notification_PDOID;
        type.notificationMessage = notificationDTO.NotificationMessage;
        return type;
    }

    public static notificationsDTO(notificationsDTO: any): any {
        let type: any = {};

        type._type = 'notificationsDTO';
        type.notifications = [];

        if (notificationsDTO.Notifications != null) {
            for (let i119 in notificationsDTO.Notifications) {
                if(notificationsDTO.Notifications.hasOwnProperty(i119)) {
                     let typeName = 'notificationDTO';
                     let hasAllProperties = true;

                     for (let property in notificationsDTO.Notifications[i119]) {
                        if(notificationsDTO.Notifications[i119].hasOwnProperty(property)) {
                            if (RADGeneratedModels.notificationDTOProperties.indexOf(property) < 0) {
                                hasAllProperties = false;
                                break;
                            }
                        }
                     }

                     if (hasAllProperties === false) {
                        if (hasAllProperties === false) {
                            let thisHasAllProperties = true;

                            for (let property in notificationsDTO.Notifications[i119]) {
                                if(notificationsDTO.Notifications[i119].hasOwnProperty(property)) {
                                    if (RADGeneratedModels.systemLockNotificationDTOProperties.indexOf(property) < 0) {
                                        thisHasAllProperties = false;
                                        break;
                                    }
                                }
                            }

                            if (thisHasAllProperties === true) {
                                typeName = 'systemLockNotificationDTO';
                            }

                            hasAllProperties = thisHasAllProperties;
                        }

                     }
                     type.notifications.push(RADGeneratedModels[typeName](notificationsDTO.Notifications[i119]));
                }
            }
        }

        return type;
    }

    public static searchEntryDTO(searchEntryDTO: any): any {
        let type: any = {};

        type._type = 'searchEntryDTO';
        type.alias = searchEntryDTO.Alias;
        type.historizationDate = searchEntryDTO.HistorizationDate;
        type.historizationGroupPDO_ID = searchEntryDTO.HistorizationGroup_PDO_ID;
        type.isHistorized = searchEntryDTO.IsHistorized;
        type.objectIdentValue = searchEntryDTO.ObjectIdentValue;
        type.pdOChanged = searchEntryDTO.PDO_Changed;
        type.pdOChangedBy = searchEntryDTO.PDO_ChangedBy;
        type.pdOCreated = searchEntryDTO.PDO_Created;
        type.pdOCreatedBy = searchEntryDTO.PDO_CreatedBy;
        type.pdoId = searchEntryDTO.PDO_ID;
        type.principal = searchEntryDTO.Principal;
        type.typeErgName = searchEntryDTO.TypeErgName;
        type.typeName = searchEntryDTO.TypeName;
        return type;
    }

    public static searchResultDTO(searchResultDTO: any): any {
        let type: any = {};

        type._type = 'searchResultDTO';
        type.entries = [];

        if (searchResultDTO.Entries != null) {
            for (let i120 in searchResultDTO.Entries) {
                if(searchResultDTO.Entries.hasOwnProperty(i120)) {
                     let typeName = 'searchEntryDTO';
                     type.entries.push(RADGeneratedModels[typeName](searchResultDTO.Entries[i120]));
                }
            }
        }

        type.extentCount = searchResultDTO.ExtentCount;
        return type;
    }

    public static searchQueryDTO(searchQueryDTO: any): any {
        let type: any = {};

        type._type = 'searchQueryDTO';
        type.extensionModules = [];

        if (searchQueryDTO.ExtensionModules != null) {
            for (let i121 in searchQueryDTO.ExtensionModules) {
                if(searchQueryDTO.ExtensionModules.hasOwnProperty(i121)) {
                     let typeName = 'extensionModuleDTO';
                     type.extensionModules.push(RADGeneratedModels[typeName](searchQueryDTO.ExtensionModules[i121]));
                }
            }
        }

        type.from = searchQueryDTO.From;
        type.historizationPointPDOID = searchQueryDTO.HistorizationPointPDO_ID;
        type.includeHistory = searchQueryDTO.IncludeHistory;
        type.pageSize = searchQueryDTO.PageSize;
        type.query = searchQueryDTO.Query;
        type.reverseSort = searchQueryDTO.ReverseSort;
        type.searchInAllPrincipals = searchQueryDTO.SearchInAllPrincipals;
        if (searchQueryDTO.SelectedType != null) {
            let typeName = 'typeMetaDTO';
            type.selectedType = RADGeneratedModels[typeName](searchQueryDTO.SelectedType);
        } else {
            type.selectedType = null;
        }

        type.sortField = searchQueryDTO.SortField;
        type.to = searchQueryDTO.To;
        return type;
    }

    public static keepAliveDTO(keepAliveDTO: any): any {
        let type: any = {};

        type._type = 'keepAliveDTO';
        type.lastCacheUpdate = keepAliveDTO.LastCacheUpdate;
        type.lastRightCacheUpdate = keepAliveDTO.LastRightCacheUpdate;
        type.notifications = [];

        if (keepAliveDTO.Notifications != null) {
            for (let i122 in keepAliveDTO.Notifications) {
                if(keepAliveDTO.Notifications.hasOwnProperty(i122)) {
                     let typeName = 'notificationDTO';
                     let hasAllProperties = true;

                     for (let property in keepAliveDTO.Notifications[i122]) {
                        if(keepAliveDTO.Notifications[i122].hasOwnProperty(property)) {
                            if (RADGeneratedModels.notificationDTOProperties.indexOf(property) < 0) {
                                hasAllProperties = false;
                                break;
                            }
                        }
                     }

                     if (hasAllProperties === false) {
                        if (hasAllProperties === false) {
                            let thisHasAllProperties = true;

                            for (let property in keepAliveDTO.Notifications[i122]) {
                                if(keepAliveDTO.Notifications[i122].hasOwnProperty(property)) {
                                    if (RADGeneratedModels.systemLockNotificationDTOProperties.indexOf(property) < 0) {
                                        thisHasAllProperties = false;
                                        break;
                                    }
                                }
                            }

                            if (thisHasAllProperties === true) {
                                typeName = 'systemLockNotificationDTO';
                            }

                            hasAllProperties = thisHasAllProperties;
                        }

                     }
                     type.notifications.push(RADGeneratedModels[typeName](keepAliveDTO.Notifications[i122]));
                }
            }
        }

        type.utcNow = keepAliveDTO.UtcNow;
        return type;
    }

    public static loginDTO(loginDTO: any): any {
        let type: any = {};

        type._type = 'loginDTO';
        type.assignedPrincipals = [];

        if (loginDTO.AssignedPrincipals != null) {
            for (let i123 in loginDTO.AssignedPrincipals) {
                if(loginDTO.AssignedPrincipals.hasOwnProperty(i123)) {
                     let typeName = 'principalDTO';
                     type.assignedPrincipals.push(RADGeneratedModels[typeName](loginDTO.AssignedPrincipals[i123]));
                }
            }
        }

        type.blockedForSeconds = loginDTO.BlockedForSeconds;
        type.blockedUntil = loginDTO.BlockedUntil;
        if (loginDTO.ClientInfo != null) {
            let typeName = 'clientInfoDTO';
            type.clientInfo = RADGeneratedModels[typeName](loginDTO.ClientInfo);
        } else {
            type.clientInfo = null;
        }

        type.defaultPersistenceContext = loginDTO.DefaultPersistenceContext;
        type.isAuthorized = loginDTO.IsAuthorized;
        if (loginDTO.Menus != null) {
            let typeName = 'menuDTO';
            type.menus = RADGeneratedModels[typeName](loginDTO.Menus);
        } else {
            type.menus = null;
        }

        type.principal = loginDTO.Principal;
        type.resultErgName = loginDTO.ResultErgName;
        type.rightCacheCreated = loginDTO.RightCacheCreated;
        if (loginDTO.Taskinformation != null) {
            let typeName = 'taskInformationDTO';
            type.taskinformation = RADGeneratedModels[typeName](loginDTO.Taskinformation);
        } else {
            type.taskinformation = null;
        }

        type.twoFATokenNeeded = loginDTO.TwoFATokenNeeded;
        type.userSpecificData = {};

        if (loginDTO.UserSpecificData != null) {
            for (let i124 in loginDTO.UserSpecificData) {
                if (loginDTO.UserSpecificData.hasOwnProperty(i124)) {
                    type.userSpecificData[i124] = loginDTO.UserSpecificData[i124];
                }
            }
        }

        return type;
    }

}
